export function hasPendingOptiRateAmendment(prospect: Prospect): boolean {
  return (
    prospect.optiRateAmendment?.status === 'PENDING' &&
    !prospect.tenant?.agreements?.TESA_OPTIRATE_AMENDMENT?.accepted
  )
}

/** OptiRate is only offered in production or the dedicated demo-optirate route. */
export function isOptiRateAmendmentOffered(
  prospectId: string | undefined,
  prospect: Prospect
): boolean {
  if (prospectId === 'demo-optirate') {
    return hasPendingOptiRateAmendment(prospect)
  }
  if (prospectId?.includes('demo')) {
    return false
  }
  return hasPendingOptiRateAmendment(prospect)
}

export function getPathAfterTesa(prospectId: string, prospect: Prospect): string {
  if (prospectId === 'demo-optirate' && isOptiRateAmendmentOffered(prospectId, prospect)) {
    return `/${prospectId}/agreements/optirate-amendment`
  }
  return `/${prospectId}/agreements/supplement`
}

export function getPathAfterSupplement(prospectId: string, prospect: Prospect): string {
  if (prospectId === 'demo-optirate') {
    if ((prospect.tesaVersion ?? 0) >= 6) {
      return `/${prospectId}/finish`
    }
    return `/${prospectId}/agreements/payment`
  }
  if (isOptiRateAmendmentOffered(prospectId, prospect) && (prospect.tesaVersion ?? 0) >= 6) {
    return `/${prospectId}/agreements/optirate-amendment`
  }
  if ((prospect.tesaVersion ?? 0) >= 6) {
    return `/${prospectId}/finish`
  }
  return `/${prospectId}/agreements/payment`
}

export function getPathAfterPayment(prospectId: string, prospect: Prospect): string {
  if (isOptiRateAmendmentOffered(prospectId, prospect)) {
    return `/${prospectId}/agreements/optirate-amendment`
  }
  return `/${prospectId}/finish`
}

export function getContinueRouteAfterOptiRate(prospectId: string, prospect: Prospect): string {
  const agreements = prospect.tenant.agreements
  if (!agreements?.TESA_SUPPLEMENT?.accepted) {
    return `/${prospectId}/agreements/supplement`
  }
  if ((prospect.tesaVersion ?? 0) < 6 && !agreements?.PRICING_AND_PAYMENT_TERMS?.accepted) {
    return `/${prospectId}/agreements/payment`
  }
  return `/${prospectId}/finish`
}

export function getPathAfterAgreementsComplete(prospectId: string, prospect: Prospect): string {
  const agreements = prospect.tenant.agreements
  const prerequisitesMet =
    agreements?.TESA?.accepted &&
    agreements?.TESA_SUPPLEMENT?.accepted &&
    ((prospect.tesaVersion ?? 0) >= 6 || agreements?.PRICING_AND_PAYMENT_TERMS?.accepted)

  if (isOptiRateAmendmentOffered(prospectId, prospect) && prerequisitesMet) {
    return `/${prospectId}/agreements/optirate-amendment`
  }
  return `/${prospectId}/finish`
}
